var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.313 7.313c0-1.302-1.705-1.81-2.415-.713-5.212 8.054 1.54 12.455 1.54 15.15a2.19 2.19 0 01-2.188 2.187 2.19 2.19 0 01-2.188-2.187v-5.79c0-1.06-1.194-1.682-2.063-1.076A10.512 10.512 0 009.5 23.5C9.5 29.29 14.21 34 20 34s10.5-4.71 10.5-10.5c0-9.313-8.4-10.6-9.188-16.187zM20 32.775c-6 0-9.45-5.175-9.45-9.275 0-2.567 1.575-6.943 4.2-7.54v5.79c0 1.75 2.046 3.225 3.5 3.225 1.454 0 3.325-.98 3.325-3.15 0-3.56-6.3-7.875-1.575-14.175 1.313 5.775 9.45 7.875 9.45 16.287 0 4.825-4.531 8.838-9.45 8.838z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarFire);
export default __webpack_public_path__ + "static/media/carFire.efc687f7de35fb9d8709c6bb5a0e9c56.svg";
export { ForwardRef as ReactComponent };